/**
 * Prcels Logs
 */

// React
import React, { useEffect, useContext } from 'react';

// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Store } from '../../redux/reducers';
import { getParcelsWithIdAction } from './actions';
import { getLogsAction } from './actions';

// Selector
import { createStructuredSelector } from 'reselect';
import { makeSelectParcel, makeSelectLogs } from './selectors';

//UI
import theme from '../../theme';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { Typography, Paper, Button, Grid, Divider } from '@material-ui/core';
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
} from '@material-ui/lab';

// Icon
import Icon from '@mdi/react';
import {
  mdiArrowRight,
  mdiDotsHorizontalCircleOutline,
  mdiMapMarkerCheckOutline,
  mdiClipboardCheckOutline,
  mdiClose,
  mdiCalendar,
  mdiWarehouse,
  mdiKeyOutline,
  mdiCalendarClock,
  mdiFileTree,
  mdiPlaylistCheck,
  mdiArrowCollapseAll,
  mdiCheckBold,
  mdiClipboardArrowLeft,
  mdiTableCheck,
  mdiTableArrowUp,
} from '@mdi/js';

// Helper
import {
  translate,
} from '../../utils/helpers';
import jMoment from 'moment-jalaali';
import Can from '../../components/Can';

// Type
import { Log } from '../parcels/interfaces';
import { SelectorProps, Props } from './interfaces';
import AuthContext from '../../authContext';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    secondaryTail: {
      backgroundColor: theme.palette.secondary.main,
    },
    paperHistory: {
      '@media (min-width: 768px)': {
        width: '40%',
      },
    },
    headerBox: {
      display: 'flex',

      alignItems: 'center',
      marginBottom: '28px',
    },
    titleBox: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.secondary.contrastText,
      padding: theme.spacing(2),
      borderRadius: '4px 4px 0 0',
    },
    contentBox: {
      padding: theme.spacing(2),
      fontSize: '14px',
      fontWeight: 500,
    },
    contentlabel: {
      color: theme.palette.gray.light,
      marginRight: '10px',
      fontWeight: 400,
    },
    contentlabelTitle: {
      position: 'relative',
      color: theme.palette.gray.light,
      marginLeft: '40px',
      fontSize: '14px',
      fontWeight: 500,
      '&:before': {
        content: '"-"',
        position: 'absolute',
        left: '-20px',
      },
    },
    missingOppositeContent: {
      '&::before': {
        flex: 'none',
      },
    },
    paper: {
      marginTop: theme.spacing(4),
      marginBottom: '36px',
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
      border: '1px solid #ddd',
      borderRadius: '4px 4px 0 0',
      '@media (max-width: 768px)': {
        padding: theme.spacing(0),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        backgroundColor: theme.palette.background.default,
      },
    },
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
      '& > *': {
        margin: theme.spacing(0, 1),
      },
    },
    divider: {
      width: '97%',
      margin: '0 auto',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      whiteSpace: 'nowrap',
    },
    icon: {
      marginRight: theme.spacing(1),
    },
  })
);

//const
const iconStatus = {
  ARRIVED: mdiMapMarkerCheckOutline, //'به مقصد رسیده',
  CANCELLED: mdiClose, //'لغو شده',
  SHIPPED: mdiDotsHorizontalCircleOutline, //'ارسال شده',
  DELIVERED: mdiClipboardCheckOutline, //'تحویل داده شده',
  SUBMITTED: mdiDotsHorizontalCircleOutline, //'ایجاد شده',
  ASSIGNED: mdiPlaylistCheck, // تخصیص داده شده
  REGISTERED: mdiCheckBold, //'منطبق شده',
  CONFLICTED: mdiArrowCollapseAll, // مغایرت داده شده
  LOCATED: mdiFileTree, // جایگذاری شده
  RETURNING: mdiClipboardArrowLeft, // ریجکت شده
  UNLOADING: mdiTableArrowUp, // در حال بارگذاری
  UNLOADED: mdiTableCheck, // بارگذاری شده
};
const colorStatus = {
  SUBMITTED: theme.palette.green.main, //'ثپت شده',
  SHIPPED: theme.palette.green.main, //'ارسال شده',
  DELIVERED: theme.palette.green.main, //'تحویل داده شده',
  REGISTERED: theme.palette.green.main, //'منطبق شده',
  CANCELLED: theme.palette.error.main, //'لغو شده',
  RETURNING: theme.palette.warning.main, //'ریجکت شده',
  UNLOADING: theme.palette.orange.main, //'در حال بارگذاری ',
  UNLOADED: theme.palette.green.main, //'بارگذاری شده',
  LOCATED: 'purple', // جایگذاری شده
  ASSIGNED: theme.palette.blue.main, // تخصیص داده شده
  CONFLICTED: theme.palette.orange.main, // مغایرت داده شده
};

export function Logs(props: Props) {
  const authContext = useContext(AuthContext);
  const classes = useStyles();

  useEffect(() => {
    const { id } = props.match.params;
    props.getLogsDispatch(id);
    props.parcelsWithIdActionDispatch(id);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div>
      <div className={classes.headerBox}>
        <Typography
          variant="h6"
          component="div"
          style={{ marginLeft: '20px', fontSize: '18px' }}
        >
          {`تاریخچه  محموله
           ${props.parcel.destinationName}
          `}
        </Typography>
        <span className={classes.contentlabelTitle}>
          {props.match.params?.id}
        </span>
      </div>
      <Button
        aria-label="details"
        size="medium"
        onClick={() => window.history.back()}
      >
        <Icon path={mdiArrowRight} size={1} className={classes.icon} />
        {`بازگشت`}
      </Button>

      <Paper elevation={3} className={classes.paper} variant="elevation" square>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={4}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiWarehouse} size={1} className={classes.icon} />
                {`ارسال کننده:  `}
              </span>

              <span>{props.parcel.partnerName ?? props.parcel.sellerName}</span>
            </div>
          </Grid>

          <Grid item xs={12} sm={4}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiWarehouse} size={1} className={classes.icon} />
                {`انبار مقصد:  `}
              </span>
              <span>
                <span>{props.parcel.destinationName}</span>
              </span>
            </div>
          </Grid>
          <Grid item xs={12} sm={4}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiKeyOutline} size={1} className={classes.icon} />
                {` شناسه محموله:  `}
              </span>
              <span>
                <span>{props.parcel.id}</span>
              </span>
            </div>
          </Grid>
          <Divider className={classes.divider} />
          <Grid item xs={12} sm={4}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiCalendar} size={1} className={classes.icon} />
                {`تاریخ ثبت محموله:`}
              </span>
              <span>
                {props.parcel.shippingDate &&
                  jMoment(props.parcel.shippingDate, 'YYYY/MM/DD')
                    .locale('fa')
                    .format('jYYYY/jMM/jDD')}
              </span>
            </div>
          </Grid>
          <Grid item xs={12} sm={4}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiCalendar} size={1} className={classes.icon} />
                {`تاریخ تحویل محموله:
  `}
              </span>
              <span>
                {props.parcel.deliveryDate &&
                  jMoment(props.parcel.deliveryDate, 'YYYY/MM/DD')
                    .locale('fa')
                    .format('jYYYY/jMM/jDD')}
              </span>
            </div>
          </Grid>
          <Grid item xs={12} sm={4}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiCalendarClock}
                  size={1}
                  className={classes.icon}
                />
                {`بازه تحویل محموله:
  `}
              </span>
              <span>
                <span>
                  {props.parcel.deliveryStartTime &&
                    jMoment(props.parcel.deliveryStartTime, 'hh:mm')
                      .locale('fa')
                      .format('HH:mm')}
                  {' - '}
                  {props.parcel.deliveryEndTime &&
                    jMoment(props.parcel.deliveryEndTime, 'hh:mm')
                      .locale('fa')
                      .format('HH:mm')}
                </span>
              </span>
            </div>
          </Grid>
        </Grid>
      </Paper>
      <Grid container>
        <Grid item xs={12}>
          <Timeline align="left">
            {props.logs
              ?.slice()
              .reverse()
              .map((log: Log, index: number) => (
                <TimelineItem
                  className={classes.missingOppositeContent}
                  key={index}
                >
                  <TimelineSeparator>
                    <TimelineDot
                      style={{
                        backgroundColor: colorStatus[log.newStatus],
                        borderColor:
                          index === 0 ? theme.palette.secondary.main : '',
                      }}
                    >
                      <Icon path={iconStatus[log.newStatus]} size={1} />
                    </TimelineDot>
                    {index !== props.logs?.length - 1 ? (
                      <TimelineConnector />
                    ) : (
                      ''
                    )}
                  </TimelineSeparator>
                  <TimelineContent>
                    <Paper elevation={3} className={classes.paperHistory}>
                      <Typography component="div" className={classes.titleBox}>
                        {log.time &&
                          jMoment(log.time, 'YYYY/MM/DDTHH:mm:ss.SSZ')
                            .locale('fa')
                            .format('jYYYY/jMM/jDD - HH:mm')}
                      </Typography>
                      <div className={classes.contentBox}>
                        <div>
                          <span className={classes.contentlabel}>
                            وضعیت محموله:
                          </span>
                          <span>{translate(log.newStatus, 'parcel')}</span>
                        </div>
                        <div style={{ marginTop: '12px' }}>
                          <span className={classes.contentlabel}>کاربر:</span>
                          <Can
                            role={authContext.user.role}
                            perform="user-name:dontShowInLogs"
                            no={() => (
                              <>
                                <span>{log.modifierName}</span>
                                <span> &nbsp; &nbsp;- &nbsp; &nbsp;</span>
                              </>
                            )}
                          />
                          <span>{translate(log.modifierRole, 'user')}</span>
                        </div>
                        {log.description && (
                          <div style={{ marginTop: '12px' }}>
                            <span className={classes.contentlabel}>
                              توضیحات:
                            </span>
                            <span>{log.description}</span>
                          </div>
                        )}
                      </div>
                    </Paper>
                  </TimelineContent>
                </TimelineItem>
              ))}
          </Timeline>
        </Grid>
      </Grid>
    </div>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  logs: makeSelectLogs(),
  parcel: makeSelectParcel(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    getLogsDispatch: (id: number) => dispatch(getLogsAction({ id })),
    parcelsWithIdActionDispatch: (id: number) =>
      dispatch(getParcelsWithIdAction({ id })),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Logs);
